import React from "react";
import "../../styles/Quiz/QuestionStep.css";

export function QuestionStepSkeleton() {
  return (
    <div className="quiz-body">
      <p className="quiz-question">
        <div
          className="skeleton-pulse"
          style={{ height: "24px", width: "70%", borderRadius: "6px" }}
        />
      </p>
      <div className="quiz-options">
        {[0, 1, 2, 3].map((i) => (
          <button
            key={i}
            className="quiz-option skeleton-pulse"
            disabled
            style={{
              background: "#f7f8fa",
              borderColor: "transparent",
              cursor: "default",
            }}
          />
        ))}
      </div>
      <div className="quiz-footer">
        <span />
        <button
          className="quiz-btn quiz-btn--primary skeleton-pulse"
          disabled
          style={{
            background: "#f7f8fa",
            color: "transparent",
            width: "140px",
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default function QuestionStep({
  index,
  question,
  selectedOption,
  onSelectOption,
  onNext,
  onBack,
  canGoBack,
  isLastQuestion,
  isSubmitting,
}) {
  return (
    <div className="quiz-body">
      <p className="quiz-question">
        {index + 1}. {question.question}
      </p>

      <div className="quiz-options">
        {question.options.map((option, i) => (
          <button
            key={i}
            className={`quiz-option ${selectedOption === i ? "quiz-option--selected" : ""}`}
            onClick={() => onSelectOption(question.id, i)}
            disabled={isSubmitting}
          >
            {option}
          </button>
        ))}
      </div>

      <div className="quiz-footer">
        {canGoBack ? (
          <button
            className="quiz-btn quiz-btn--ghost"
            onClick={onBack}
            disabled={isSubmitting}
          >
            Go back
          </button>
        ) : (
          <span />
        )}
        <button
          className="quiz-btn quiz-btn--primary"
          onClick={onNext}
          disabled={selectedOption === undefined || isSubmitting}
        >
          {isSubmitting
            ? "Submitting..."
            : isLastQuestion
              ? "Find out your best match"
              : "Next question"}
        </button>
      </div>
    </div>
  );
}
